
  // Extract a portion of the referring web-address
  export const getReferrer = () => {
    const r = window.location.href.replace(`${window.location.origin}`, "");
    return r && r.length > 1 ? r.split('?')[0] : "";
};